import { blue, emerald, orange, red, slate, yellow } from '@/lib/colours';

import { Chip, type ChipProps } from '@/primitives';

export enum Sentiment {
  Negative = 'negative',
  Tentative = 'tentative',
  Warning = 'warning',
  Positive = 'positive',
  Neutral = 'neutral',
  Informative = 'informative',
  InProgress = 'inProgress',
}

export const sentimentColorMap = {
  [Sentiment.Negative]: red[500],
  [Sentiment.Tentative]: yellow[600],
  [Sentiment.Warning]: orange[600],
  [Sentiment.Positive]: emerald[500],
  [Sentiment.Neutral]: slate[600],
  [Sentiment.Informative]: blue[600],
  [Sentiment.InProgress]: blue[600],
};

export const sentimentBackgroundColorMap = {
  [Sentiment.Negative]: red[100],
  [Sentiment.Tentative]: yellow[100],
  [Sentiment.Warning]: orange[100],
  [Sentiment.Positive]: emerald[100],
  [Sentiment.Neutral]: slate[100],
  [Sentiment.Informative]: blue[100],
  [Sentiment.InProgress]: blue[100],
};

export interface StatusChipProps extends ChipProps {
  sentiment: Sentiment;
}

export function StatusChip({ sentiment, ...props }: StatusChipProps) {
  return (
    <Chip
      {...props}
      sx={{
        backgroundColor: sentimentBackgroundColorMap[sentiment],
        color: sentimentColorMap[sentiment],
        ...props.sx,
      }}
    />
  );
}
